import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()

export class Utils {

    constructor() {
    }

    handleError(error: HttpErrorResponse): string {
        if (error.status >= 500 && error.status < 600 && error.error != null) {
            let errorCode = error.error.code;
            if (errorCode == '1') {
                return 'Niespodziewany błąd.';
            }
            else if (errorCode == '2') {
                return 'Nie ma na parkingu biletu o wprowadzonym numerze.';
            }
            else if (errorCode == '3') {
                return error.error.exception.message;
            }
            else if (errorCode == '4') {
                return 'Użytkownik nie jest zalogowany.';
            }
            else if (errorCode == '5') {
                return 'Nieznany login lub nieprawidłowe hasło.';
            }
            else if (errorCode == '6') {
                return 'Nie można zmienić hasła.';
            }
            else if (errorCode == '7') {
                return 'Nie można zresetować hasła dla użytkownika.';
            }
            else if (errorCode == '8') {
                return 'Nie można wysłać wiadomości do użytkownika.';
            }
            else if (errorCode == '9') {
                return 'Błąd podczas tworzenia użytkownika.';
            }
            else if (errorCode == '10') {
                return 'Błąd komunikacji z systemem SkiData.';
            }
            else if (errorCode == '11') {
                return 'Bilet został już zwalidowany';
            }
            else if (errorCode == '18') {
                return 'Nieprawidłowa konfiguracja walidacji';
            }
            else if (errorCode == '19') {
                return 'Podany login już istnieje. Proszę wybrać nowy login - może to być adres e-mail.';
            }
            else if (errorCode == '20') {
                return 'Nieprawidłowy parametr wywołania: ' + (error.error.exception ? error.error.exception.message : '');
            }
        }
    }
}
